<script>
  export let story
</script>

<p class="container">{story}</p>

<style>
  .container {
    height: 50px;
    padding-top: 25px;
    color: rgba(46, 46, 46, 0.878);
  }
</style>
